module.exports = __webpack_public_path__ + "img/compact.5e23649e.png";